/**
 * @license
 * @copyright Copyright Motili Inc., 2026 All Rights Reserved
 */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { featureFlag } from 'common/services/UtilityService';

export const FEATURES = {
    DASHBOARD: 'dashboard',
};

const initialState = {
    dashboard: {
        loading: undefined as boolean | undefined,
        enabled: false,
        initialized: false,
    },
};
const featuresFlagSlice = createSlice({
    name: 'featuresFlag',
    initialState,
    reducers: {
        reset: () => initialState,
        disableDashboard: state => {
            state.dashboard.enabled = false;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchFeatureFlag.pending, (state, action) => {
                return {
                    ...state,
                    [action.meta.arg]: {
                        loading: true,
                        enabled: false,
                        initialized: true,
                    },
                };
            })
            .addCase(fetchFeatureFlag.fulfilled, (state, action) => {
                return {
                    ...state,
                    [action.meta.arg]: {
                        loading: false,
                        enabled: action.payload || false,
                        initialized: true,
                    },
                };
            })

            .addCase(fetchFeatureFlag.rejected, (state, action) => {
                return {
                    ...state,
                    [action.meta.arg]: {
                        loading: false,
                        enabled: false,
                        initialized: true,
                    },
                };
            });
    },
});
export const { disableDashboard } = featuresFlagSlice.actions;
export default featuresFlagSlice.reducer;

export const fetchFeatureFlag = createAsyncThunk<boolean, string>(
    'featuresFlag/fetchFeatureFlag',
    async feature => {
        return featureFlag(feature);
    }
);
